import { render, staticRenderFns } from "./TemplatePage.vue?vue&type=template&id=17333fc8&scoped=true&"
import script from "./TemplatePage.vue?vue&type=script&lang=ts&"
export * from "./TemplatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17333fc8",
  null
  
)

export default component.exports